// extracted by mini-css-extract-plugin
module.exports = {"confirmation-badge":"ConfirmationBadge_confirmation-badge__gCjiO","confirmation-badge__label":"ConfirmationBadge_confirmation-badge__label__gyUN_"};